import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from './../../services/auth.service';

@Component({
  selector: 'app-auth-bar',
  templateUrl: './auth-bar.component.html',
  styleUrls: ['./auth-bar.component.scss'],
})
export class AuthBarComponent implements OnInit {
  @Output() userProfileEvent = new EventEmitter<any>();
  public user:any;
  constructor(public auth: AuthService) {
    auth.userProfile$.subscribe( (user:any)=>{
      setTimeout( ()=>{
        this.user = user;
        this.userProfileEvent.emit(user);
      },1);
    })
  }

  ngOnInit() {
  }

}
